import { Tag, TagVariant } from '@deliveryhero/pd-cookbook/components/Tag';
import { GiftCard, GiftCardState } from 'services/api';
import { Column } from 'src/components/TableList/SortableHeader';

export const GiftCardListingColumns: (
  currencyCode: string
) => Column<GiftCard>[] = (currencyCode: string) => [
  {
    id: 'order_time',
    label: 'Order date',
    format: (giftCard) => {
      return new Date(giftCard.order_time).toLocaleDateString();
    }
  },
  {
    id: 'external_order_number',
    label: 'Order no.'
  },
  {
    id: 'value',
    label: 'Amount',
    format: (giftCard) => {
      return `${currencyCode} ${giftCard.value}`;
    }
  },
  {
    id: 'quantity',
    label: 'Quantity'
  },
  {
    id: 'total',
    label: 'Total',
    format: (giftCard) => {
      return `${currencyCode} ${giftCard.total}`;
    }
  },
  {
    id: 'state',
    label: 'Status',
    format: (giftCard) => {
      if (giftCard.state === GiftCardState.PROCESSING) {
        return (
          <Tag
            id={GiftCardState.PROCESSING}
            label="Pending payment"
            variant={TagVariant.POPULAR}
          />
        );
      } else if (giftCard.state === GiftCardState.PENDING) {
        // todo: Inaccessible branch until QC enables PENDING state
        return (
          <Tag
            id={GiftCardState.PENDING}
            label="Pending payment"
            variant={TagVariant.POPULAR}
          />
        );
      } else if (giftCard.state === GiftCardState.PAYMENT_PROCESSING) {
        return (
          <Tag
            id={GiftCardState.PAYMENT_PROCESSING}
            label="Processing payment"
            variant={TagVariant.POPULAR}
          />
        );
      } else if (giftCard.state === GiftCardState.COMPLETE) {
        return (
          <Tag
            id={GiftCardState.COMPLETE}
            label="Delivered"
            variant={TagVariant.SUCCESS}
          />
        );
      } else if (giftCard.state === GiftCardState.PAYMENT_REJECTED) {
        return (
          <Tag
            id={GiftCardState.PAYMENT_REJECTED}
            label="Payment Rejected"
            variant={TagVariant.ERROR}
          />
        );
      } else if (giftCard.state === GiftCardState.PARTIALLY_FAILED) {
        return (
          <Tag id="ERROR" label="Partially failed" variant={TagVariant.ERROR} />
        );
      } else {
        return <Tag id="ERROR" label="Cancelled" variant={TagVariant.ERROR} />;
      }
    }
  }
];
